import { render } from "./DespachoMetas.vue?vue&type=template&id=26643be6"
import script from "./DespachoMetas.vue?vue&type=script&lang=js"
export * from "./DespachoMetas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__